/* ─── record_user_login.ts ───────────────────────────────────────── */
import { call, takeLeading } from 'redux-saga/effects';
import { pingLogin }         from '../utils/lrs';

let pingSent = false;           // per-tab flag

export default function* recordUserLogin(): Generator {

  /*
  yield takeLeading('RECORD_USER_LOGIN', function* (action: any): Generator {
    if (pingSent) return;       // no double-pings
    pingSent = true;

    const { userId, semelMosad = '' } = action.payload;
    yield call(pingLogin, userId, semelMosad);
  });
  */

}
